// extracted by mini-css-extract-plugin
export var drawerContent = "_2q-0";
export var valueBlock = "_2q-1";
export var valueBlockFrom = "_2q-2 _2q-1";
export var valueBlockTo = "_2q-3 _2q-1";